<template>
    <div>
        <action-bar>
            <router-link :to="{name: 'umbrella-project-create'}">Neues Verbundprojekt erstellen</router-link>
        </action-bar>
        <main class="content">
            <h1>Verbundprojekte</h1>
            <project-list :projects="projects" v-if="projects" type="umbrella"></project-list>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  asyncComputed: {
    projects() {
      return axios
        .get("/api/" + store.state.language + "/umbrella_project/list")
        .then(({ data }) => {
          return data.result;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/umbrella_project/List.vue